import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className="footer-layout4 shape-mockup-wrap"
      style={{
        backgroundImage: "url(/assets/img/bg/footer-bg-4.jpg)",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="widget-area2">
        <div className="container">
          <div className="row g-5 justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <div className="vs-widget-about">
                  <div className="footer-logo text-start d-block text-md-start">
                    <Link to="index.html">
                      <img
                        src="/img/logo2.jpg"
                        alt="Travolo"
                        className="logo"
                        height={100}
                        width={150}
                      />
                    </Link>
                  </div>

                  <p className="footer-text" style={{ textAlign: "justify" }}>
                    City Life Vacation Homes offers a variety of premium
                    vacation rentals in Dubai, catering to both business and
                    leisure travelers. With a focus on comfort, convenience, and
                    exceptional service, we ensure that your stay is memorable
                    and stress-free.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Official Info</h3>
                <div className="menu-all-pages-container">
                  <ul className="contact-info-list d-flex flex-column gap-2">
                    <li className="d-flex gap-2 align-items-center w-100">
                      <i className="fas fa-phone"></i>
                      <a className="mb-0" href="tel:+971561184114">
                        +971 56 118 4114
                      </a>
                    </li>
                    <li className="d-flex gap-2 align-items-center w-100">
                      <i className="fas fa-envelope"></i>
                      <a className="mb-0" href="mailto:info@citylifevhr.com">
                        info@citylifevhr.com
                      </a>
                    </li>
                    <li className="d-flex gap-2 align-items-center w-100">
                      <i className="fas fa-map-marker-alt"></i>

                      <a className="mb-0" href="##">
                        Al Murar, Deira, Dubai, UAE
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="social-style1 mt-4">
                <Link
                  to="https://www.facebook.com/people/City-Life-Vacation-Homes-Rental-LLC-Dubai/61560822997286/"
                  target="_blank"
                >
                  <i className="fab fa-facebook-f"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-instagram"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-pinterest-p"></i>
                </Link>
                <Link to="#" target="_blank">
                  <i className="fab fa-twitter"></i>
                </Link>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Useful Links</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu d-flex flex-column">
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/properties">Properties</Link>
                    </li>
                    <li>
                      <Link to="/gallery">Gallery</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <h4 className="widget_title">Footer Gallery</h4>
                <div className="sidebar-gallery">
                  <a href="/img/property/1.jpg" className="popup-image">
                    <img
                      src="/img/property/1.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                  <a href="/img/property/2.jpg" className="popup-image">
                    <img
                      src="/img/property/2.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                  <a href="/img/property/3.jpg" className="popup-image">
                    <img
                      src="/img/property/3.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                  <a href="/img/property/4.jpg" className="popup-image">
                    <img
                      src="/img/property/4.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                  <a href="/img/property/5.jpg" className="popup-image">
                    <img
                      src="/img/property/5.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                  <a href="/img/property/6.jpg" className="popup-image">
                    <img
                      src="/img/property/6.jpg"
                      alt="Gallery Imagee"
                      className="w-100"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="copyright-wrap">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-auto">
              <p className="copyright-text">
                Copyright © {new Date().getFullYear()}&nbsp;
                <Link to="/">City Life Vacation Homes Rental LLC</Link>.
                Developed By&nbsp;
                <Link target="_blank" to="https://mahfuzztwohaa.netlify.app">
                  ToxiCoder
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
